export enum ConnectionStatus {
    Connected = 'Connected',
    Disconnected = 'Disconnected',
    Online = 'Online',
    Offline = 'Offline',
    Closed = 'Closed',
  }